<style scoped lang="less">
.resourbtn {
	padding: 15px 10px;
	// border: 1px solid;
	background-color: #fff;
	margin-bottom: 20px;

	/deep/ .el-button {
		i {
			margin-right: 5px;
			font-size: 16px;
		}

		span {
			margin-right: 0 !important;
		}
	}

	button {
		background-color: #0a68e3;
		border: none;
	}
	button:last-child {
		background-color: #ff8300;
	}

	button:nth-of-type(2) {
		background-color: #ff4168;
	}
}

.manageselect {
	display: flex;
	// border: 1px solid;
	padding: 20px;
	background-color: #fff;
	box-sizing: 0 5px 5px 5px rgba(255, 255, 255, 0.6);
	border-radius: 10px;
	margin-bottom: 20px;
	.sclectlable {
		margin-right: 20px;
	}
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}
.tabslis {
	button {
		color: #fff;
	}

	.scopefont {
		color: #fff;
		width: 80%;
		margin: 0 auto;
		border-radius: 1px;
	}

	/deep/ th {
		text-align: center;
	}

	/deep/ td {
		text-align: center;
	}

	.scostatus {
		margin: auto;
		border-radius: 10px;
		color: #fff;
		width: 60px;
		// padding: 2px 0;
		font-size: 12px;
		background-color: #f41127;
	}
}
</style>
<template>
	<div>
		<div class="manageselect">
			<div class="sclectlable">
				<div><el-input placeholder="请输入课程名称" v-model="input" clearable></el-input></div>
			</div>

			<!-- <div class="sclectlable">
				<div><el-date-picker v-model="value1" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
			</div> -->

			<div class="primarybtn"><el-button @click="getname()" type="primary" icon="el-icon-search">搜索</el-button></div>
		</div>
		
		<div class="tables">
			<div class="primarybtn"><el-button @click="setcours()" type="primary">添加课程</el-button></div>
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changetablesize(tabsnun)" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="tabsnun" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table ref="multipleTable" :data="tableData" @selection-change="handleSelectionChange" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column label="专业" prop="pro_name"></el-table-column>
							<el-table-column label="课程名称" prop="CO_CoursesName"></el-table-column>
							<el-table-column label="创建者" prop="CO_Creator"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesobj.pageSize }}</span>
						,共
						<span>{{ totalall }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination
							@current-change="changecurr"
							background
							layout="prev, pager, next"
							:page-size="pagesobj.pageSize"
							:total="totalall"
							:current-page="pagesobj.pageIndex"
						></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getGetCourseList, changeAuditCousers, changeMarkasRecommended, changeOffshelfCousers, changeOffEnableCousers } from '@/request/api/homesview/yunhomes/yunhom.js';

import { changedateString } from '@/utils/utils.js';

export default {
	props:{
		chioceid:String
	},
	data() {
		return {
			value1: '',
			// 标题
			paths: [
				{
					path: '/homesview/examinationmanage/examinationmanage',
					name: '成绩管理'
				}
			],
			tabsnum: 10,
			totalall: 0,
			tabindex: 1,
			// 专业筛选项列表
			options: [],
			value: '',
			input: '',
			pagesobj: {
				pageSize: 10,
				pageIndex: 1,
				CategoryID: '', // 类别
				ProfessionalID: '', //专业
				PR_GUID: '', //岗位
				CourseName: '', //课程名称
				Inspectionlevel: '', //等级
				StartTime: '',
				EndTime: ''
			},
			tabsnun: 1,
			tableData: []
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		changetablesize(val){
			this.pagesobj.pageIndex = val
			this.gettableData();
		},
		setcours(){
			if(this.selectionobj.CO_GUID == ''){
				this.$$message("请选择课程")
				return
			}
			
			this.$emit('coust-change',JSON.stringify(this.selectionobj))
			
			
		},
		
		init() {
			this.gettableData();
		},
		handleSelectionChange(val) {
			if (val.length > 1) {
				this.$refs.multipleTable.clearSelection();
				this.$refs.multipleTable.toggleRowSelection(val.pop());
			}
			this.selectionobj = val[0];
		},
		gocoursedetil(itm) {
			this.$router.push('/course/cours/clouddeteamange?coguid=' + itm.CO_GUID);
			// /course/cours/clouddeteamange?coguid=d27cf2f920c94174aac8bb2c165cfd7e
		},
		// 前往编辑页面
		geteditcourse(itm) {
			this.$router.push('/course/cours/editcourse?coguid=' + itm.CO_GUID);
		},

		// 审核，最热最新推荐
		confirmcouse(itm) {
			let data = {
				CO_GUID: itm.CO_GUID
			};

			changeAuditCousers(data).then(res => {
				if (res.data.code > 0) {
					this.gettableData();
					this.$message.success(res.data.msg);
				}
			});
		},
		chengemcouse(i, itm) {
			let COobj = {
				CO_GUID: itm.CO_GUID,
				Type: i
			};
			// console.log(COobj)
			changeMarkasRecommended(COobj).then(res => {
				if (res.data.code > 0) {
					this.gettableData();
					this.$message.success(res.data.msg);
				}
			});
		},
		chengesxj(itm) {
			// 上下架
			let data = {
				CO_GUID: itm.CO_GUID
			};
			if (itm.CO_OnOrOff == 1) {
				changeOffshelfCousers(data).then(res => {
					if (res.data.code > 0) {
						this.gettableData();
						this.$message.success(res.data.msg);
					}
				});
			} else {
				changeOffEnableCousers(data).then(res => {
					if (res.data.code > 0) {
						this.gettableData();
						this.$message.success(res.data.msg);
					}
				});
			}
		},

		getname() {
			this.pagesobj.CourseName = this.input;

			if (this.value1 != '') {
				this.pagesobj.StartTime = changedateString(this.value1[0]).hasTime;
				this.pagesobj.EndTime = changedateString(this.value1[1]).hasTime;
			}
			// console.log(this.pagesobj)
			this.gettableData();
		},
		indexMethod(index) {
			return index + 1;
		},
		changecurr(val) {
			// console.log(val);
			this.pagesobj.pageIndex = val
			this.gettableData()
		},
		gettableData() {
			getGetCourseList(this.pagesobj).then(res => {
				// console.log(res)
				this.tableData = res.data.data.list;
				this.totalall = res.data.data.totalCount;
				
				if (this.tableData.length > 0) {
					this.$nextTick(() => {
						this.tableData.forEach((item, index) => {
							if (item.CO_GUID == this.chioceid) {
								// console.log("所有aaaaa",this.chioceid)
								this.$refs.multipleTable.toggleRowSelection(item, true);
							}
						});
					});
				}
				
			});
		}
	}
};
</script>
